module.exports = __webpack_public_path__ + "static/assets/a95c62bdee1c1952846ec46f10bdd12d.svg";